<div class="checklist-electrical">
  <div class="row">
    <!-- Scope of Work Section -->
    <div class="col-sm-6" [formGroup]="scopeOfWorkFormGroup" trackChanges>
      <fieldset class="border rounded-3 p-1 h-100">
        <legend>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_LEGEND_SCOPE_OF_WORK' | translate }}</legend>
        
        <!-- Bill of Materials Required -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_BILL_OF_MATERIALS_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="bomRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled">
              </si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled">
              </si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Provided by -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_PROVIDED_BY' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="bomProvidedBy">
              <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled">
              </si-radio-button>
              <si-radio-button [displayText]="'THIRD_PARTY' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled">
              </si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- BOM Document Received -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_BOM_DOCUMENT_RECEIVED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="bomDocumentReceived">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Written Specifications Available -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_WRITTEN_SPECIFICATIONS_AVAILABLE' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="writtenSpecificationsAvailable">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Specification Provider -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SPECIFICATION_PROVIDER' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="specificationProvider">
              <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'THIRD_PARTY' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Specification Document Available -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SPECIFICATION_DOCUMENT_AVAILABLE' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="specificationDocumentAvailable">
              <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'THIRD_PARTY' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- DDR Known -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_DDR_DIVISION_OF_RESPONSIBILITY_KNOWN' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex flex-nowrap" formControlName="ddrKnown">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'N_A' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button> 
            </mat-radio-group>
          </div>
        </div>

        <!-- Engineering Required -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_ENGINEERING_REQUIRED' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_ENGINEERING_REQUIRED' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="engineeringRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Provided by (Engineering) -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_PROVIDED_BY_ENGINEERING' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="engineeringProvidedBy">
              <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'THIRD_PARTY' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- PE Stamp Required -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_PE_STAMP_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="peStampRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Technical Solution Reviewed -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_TECHNICAL_SOLUTION_REVIEWED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex flex-nowrap" formControlName="technicalSolutionReviewed">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'N_A' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

      </fieldset>
    </div>

    <!-- Documentation Section -->
    <div class="col-sm-6" [formGroup]="documentationFormGroup" trackChanges>
      <fieldset class="border rounded-3 p-1 h-100">
        <legend>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_LEGEND_DOCUMENTATION' | translate }}</legend>

        <!-- As-Built Drawings Provided -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_AS_BUILT_DRAWINGS_PROVIDED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="asBuiltDrawingsProvided">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- One-Line Drawings Provided -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_ONE_LINE_DRAWINGS_PROVIDED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="oneLineDrawingsProvided">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Wiring Diagrams Provided -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_WIRING_DIAGRAMS_PROVIDED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="wiringDiagramsProvided">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Equipment Settings / Power System Studies Provided -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_EQUIPMENT_SETTINGS_POWER_SYSTEM_STUDIES_PROVIDED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="equipmentSettingsOrPowerSystemStudiesProvided">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Photographs Provided -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_PHOTOGRAPHS_PROVIDED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="photographsProvided">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- NamePlates Provided -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_NAMEPLATES_PROVIDED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="nameplatesProvided">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Comments -->
        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_COMMENTS' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <si-text-area
              formControlName="documentationComments"
              [isReadMode]="isReadMode" [isDisabled]="isDisabled">
            </si-text-area>
          </div>
        </div>

      </fieldset>
    </div>
  </div>

  <div class="row mt-3">
    <!-- Safety Section -->
    <div class="col-sm-6" [formGroup]="safetyFormGroup" trackChanges>
      <fieldset class="border rounded-3 p-1 h-100">
        <legend>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_LEGEND_SAFETY' | translate }}</legend>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_CUSTOMER_SITE_SAFETY_REQUIRED' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_CUSTOMER_SITE_SAFETY_REQUIRED' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="customerSiteSafetyRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SAFETY_OBSERVER_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="safetyObserverRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SUPPLIED_BY' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="safetyObserverSuppliedBy">
              <si-radio-button [displayText]="'CUSTOMER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_OUTAGE_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="outageRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_TEMPORARY_POWER_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="temporaryPowerRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_HAZARDOUS_MATERIALS_PRESENT' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_HAZARDOUS_MATERIALS_PRESENT' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="hazardousMaterialsPresent">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

      </fieldset>
    </div>

    <!-- Site Accessibility Section -->
    <div class="col-sm-6" [formGroup]="siteAccessibilityFormGroup" trackChanges>
      <fieldset class="border rounded-3 p-1 h-100">
        <legend>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_LEGEND_SITE_ACCESSIBILITY' | translate }}</legend>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_ESCORTS_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="escortsRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SECURITY_ACCESS_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="securityAccessRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_TIME_OF_DAY_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="timeOfDayRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SPECIAL_CONSIDERATIONS_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="specialConsiderationsRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </fieldset>
    </div>
  </div>

  <div class="row mt-3">
    <!-- Labor and Materials Section -->
    <div class="col-sm-6" [formGroup]="laborAndMaterialsFormGroup" trackChanges>
      <fieldset class="border rounded-3 p-1 h-100">
        <legend>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_LEGEND_LABOR_AND_MATERIALS' | translate }}</legend>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_MANPOWER_STAFFING_IN_PLACE' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="manpowerStaffingInPlace">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_TRAVEL_IS_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="travelIsRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_COSTS_INCLUDED_IN_ESTIMATE' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_COSTS_INCLUDED_IN_ESTIMATE' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="costsIncludedInEstimate">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_MATERIAL_PRICING_AND_DELIVERY_INCLUDED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="materialPricingAndDeliveryIncluded">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SIEMENS_MATERIAL_PRICING_CONFIRMED' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_SIEMENS_MATERIAL_PRICING_CONFIRMED' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="siemensMaterialPricingConfirmed">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SIEMENS_MATERIAL_DELIVERY_DATE_ESTIMATED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="siemensMaterialDeliveryDateEstimated">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_THIRD_PARTY_MATERIAL_PRICING_CONFIRMED' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_THIRD_PARTY_MATERIAL_PRICING_CONFIRMED' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="thirdPartyMaterialPricingConfirmed">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_THIRD_PARTY_MATERIAL_DELIVERY_DATE_ESTIMATED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="thirdPartyMaterialDeliveryDateEstimated">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_WORK_HOUR_REQUIREMENTS' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_WORK_HOUR_REQUIREMENTS' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="workHourRequirements">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_PROGRESS_MEETINGS_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="progressMeetingsRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_UNION_CONSIDERATIONS' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="unionConsiderations">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

      </fieldset>
    </div>

    <!-- Equipment Section -->
    <div class="col-sm-6" [formGroup]="equipmentFormGroup" trackChanges>
      <fieldset class="border rounded-3 p-1 h-100">
        <legend>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_LEGEND_EQUIPMENT' | translate }}</legend>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLS_AND_TEST_EQUIPMENT_REQUIRED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="toolsAndTestEquipmentRequired">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label class="ps-3">{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_EQUIPMENT_RENTAL_ETC_ESTIMATED' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_EQUIPMENT_RENTAL_ETC_ESTIMATED' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="equipmentRentalEtcEstimated">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SPECIAL_EQUIPMENT_LIST' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <si-check-box-group
              formControlName="specialEquipmentList"
              [options]="specialEquipmentOptions"
              [isReadMode]="isReadMode" [isDisabled]="isDisabled"
              [columnsPerRow]="1">
            </si-check-box-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_RESPONSIBLE_FOR_PROVIDING' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="responsibleForProviding">
              <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'3RD_PARTY' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'CUSTOMER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </fieldset>
    </div>
  </div>

  <div class="row mt-3">
    <!-- Provided Documents Section -->
    <div class="col-sm-6" [formGroup]="providedDocumentsFormGroup" trackChanges>
      <fieldset class="border rounded-3 p-1 h-100">
        <legend>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_LEGEND_PROVIDED_DOCUMENTS' | translate }}</legend>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_BOOKING_PACKAGE_SIGNED' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_BOOKING_PACKAGE_SIGNED' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="bookingPackageSigned">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SCOPE_OF_WORK_REVIEWED_VALIDATED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex" formControlName="scopeOfWorkReviewedAndValidated">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

      </fieldset>
    </div>

    <!-- Subcontractors Section -->
    <div class="col-sm-6" [formGroup]="subcontractorsFormGroup" trackChanges>
      <fieldset class="border rounded-3 p-1 h-100">
        <legend>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_LEGEND_SUBCONTRACTORS' | translate }}</legend>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_SUBCONTRACTOR_TERMS_AND_CONDITIONS' | translate }}
              <mat-icon class="info-icon" [matTooltip]="'REVIEW_SOL_CHECKLIST_ELECTRICAL_TOOLTIP_SUBCONTRACTOR_TERMS_AND_CONDITIONS' | translate">info</mat-icon>
            </mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex flex-nowrap" formControlName="subcontractorTermsAndConditions">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'N_A' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_VENDOR_PRICING_CONFIRMED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex flex-nowrap" formControlName="vendorPricingConfirmed">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'N_A' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row bottomPadding">
          <div class="col-sm-6">
            <mat-label>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_ADDITIONAL_MATERIAL_PRICE_AND_DELIVERY_CONFIRMED' | translate }}</mat-label>
          </div>
          <div class="col-sm-6">
            <mat-radio-group class="radio-group radio-btns d-flex flex-nowrap" formControlName="additionalMaterialPriceAndDeliveryConfirmed">
              <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
              <si-radio-button [displayText]="'N_A' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"></si-radio-button>
            </mat-radio-group>
          </div>
        </div>

      </fieldset>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-sm-6" [formGroup]="commentsFormGroup" trackChanges>
      <fieldset class="border rounded-3 p-1 h-100">
        <legend>{{ 'REVIEW_SOL_CHECKLIST_ELECTRICAL_LEGEND_COMMENTS_CONCERNS' | translate }}</legend>

        <div class="row bottomPadding">
          <div class="col-sm-12 text-area-container">
            <si-text-area
              formControlName="comments"
              [isReadMode]="isReadMode" [isDisabled]="isDisabled">
            </si-text-area>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</div>

